import React, { useEffect, useRef, useState } from 'react'
import $ from 'jquery'

import { getCollection } from '../data/collection'
import { loadScript } from '../loadScript'
import AutoVideo from './AutoVideo'
import { useT } from '../i18n'

// Wait this long before starting a hover preview. Sweeping the cursor across
// the grid would otherwise kick off a download per tile it crosses, and these
// are the full artworks — 45 animated works, ~305 MB total, averaging 6.8 MB
// and peaking at a 42 MB gif.
const HOVER_INTENT_MS = 150

const isGif = (value) => /\.gif$/i.test(value.popupSrc || '')
const isAnimated = (value) => /\.(mp4|webm|gif)$/i.test(value.popupSrc || '')

const CollectionMasonry = () => {
  const { t } = useT()
  const CollectionCollage = getCollection()

  // Index of the tile currently previewing, or null. Deliberately a single
  // value: only one artwork streams at a time, and moving away unmounts the
  // element, which aborts the in-flight request.
  const [preview, setPreview] = useState(null)
  const hoverTimer = useRef(null)

  const startPreview = (index, value) => {
    if (!isAnimated(value)) return
    clearTimeout(hoverTimer.current)
    hoverTimer.current = setTimeout(() => setPreview(index), HOVER_INTENT_MS)
  }

  const stopPreview = () => {
    clearTimeout(hoverTimer.current)
    setPreview(null)
  }

  useEffect(() => () => clearTimeout(hoverTimer.current), [])

  useEffect(() => {
    let cancelled = false
    // masonry.js lays the grid out from its own $(document).ready() handler.
    // That only fires on first load, so the layout has to be re-applied
    // explicitly whenever this component mounts again.
    loadScript('/assets/js/masonry.js')
      .then(() => {
        if (cancelled || !$.fn || !$.fn.masonry) return
        $('.grid').masonry({ itemSelector: '.grid-item' })
      })
      .catch((err) => console.error('[collection] masonry failed to load:', err))
    return () => { cancelled = true }
  }, [])

  const clickPop = (e) => {
    /* const id = e.target.attributes.getNamedItem("datagrid").value; */
    var datagrid = e.target.getAttribute("datagrid");
    var thismans = CollectionCollage[datagrid];
    var thislightbox = $(".custom-lightbox").eq(datagrid);
    var thispar = thislightbox.closest(".grid-item");
    var custom_lightbox = thispar.find('.custom-lightbox');

    // Scoped to .lightbox-content deliberately. A bare find('video') / find('img')
    // also matches the tile's own thumbnail — and now the hover preview — so it
    // would rewrite the grid tile's src with the full-size artwork instead of
    // only populating the modal.
    var vid = custom_lightbox.find('.lightbox-content video');
    if (vid.length > 0) {
      vid.attr("src", thismans['popupSrc']);
      setTimeout(() => {
        custom_lightbox.addClass('showlight');
        vid[0].play();
      }, 500);

    }
    else {
      var img = custom_lightbox.find('.lightbox-content img');
      img.attr("src", thismans['popupSrc']);
      custom_lightbox.addClass('showlight');
    }
  }

  return (
    <>
      <div className="masonary__sec">
        <div className="masonary__inner">
          <div className="grid js-masonry" data-masonry='{ "itemSelector": ".grid-item"}'>

            {
              CollectionCollage.map((value, index) => {
                return <div className="grid-item">
                  <div
                    className={`custom-lightbox${preview === index ? ' is-previewing' : ''}`}
                    onMouseEnter={() => startPreview(index, value)}
                    onMouseLeave={stopPreview}
                  >
                    <div onClick={clickPop} dataGrid={index} className="click_surface">
                    </div>
                    <a>
                      <img src={value.poster} alt={`${value.title} by ${value.author}`} loading="lazy" decoding="async" />
                    </a>
                    {preview === index && (
                      isGif(value)
                        ? <img className="tile__preview" src={value.popupSrc} alt="" aria-hidden="true" />
                        : <AutoVideo className="tile__preview" src={value.popupSrc} poster={value.poster} aria-hidden="true" />
                    )}
                    <div className="lightbox-content">
                      <div className="close_light">close</div>

                      <div className="masonary_nav pre_pop">
                        <svg ariaHidden="true" focusable="false" dataPrefix="fal" dataicon="chevron-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" className="svg-inline--fa fa-chevron-left fa-w-8"><path fill="#fff" d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z" className=""></path></svg>
                      </div>
                      <div className="masonary_nav next_pop">
                        <svg ariaHidden="true" focusable="false" dataPrefix="fal" dataicon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" className="svg-inline--fa fa-chevron-right fa-w-8"><path fill="#fff" d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z" className=""></path></svg>
                      </div>

                      {value.type == 'img' ? (
                        <img alt="" />
                      ) :
                        /* `poster` gives the lightbox something to show instead of
                           an empty black box, which reads as "the artwork is
                           missing". `src` is deliberately omitted: clickPop sets
                           it on open, so 66 tiles do not each fetch a video. */
                        <video muted loop controls playsInline preload="metadata" poster={value.poster}></video>
                      }
                      <div className="grid__content">
                        <h4 className="title_name">{value.title}</h4>
                        <h5 className="artist_name">{value.author}</h5>
                        <a target="_blank" rel="noreferrer" href={value.href} className="css_btn artwork_link"><span>{t('collection.goToArtwork')}</span></a>
                      </div>
                    </div>
                  </div>
                </div>
              })
            }

          </div>
        </div>
      </div>
    </>
  )


}

export default CollectionMasonry